// Cart-drawer offer loader and featured-upgrade action.
(() => {
  const SECTION_ID = 'cm-cart-cross-sell';
  const CART_ROOT_SELECTOR = '[data-load-target="cart-drawer"]';
  const ITEM_LIST_SELECTOR =
    '[data-load-target="cart-drawer"] .drawer--right > form.contents > .drawer__content[class*="flex-1"] > [class*="divide-y"]';
  const MOUNTED_OFFER_SELECTOR =
    '[data-load-target="cart-drawer"] .drawer--right > form.contents .cm-cart-cross-sell';

  let cachedBlock = null;
  let hasFetched = false;
  let requestInFlight = false;
  let refreshQueued = false;
  let cacheVersion = 0;

  const cloneCachedBlock = () => cachedBlock?.cloneNode(true) || null;

  const injectCachedBlock = () => {
    const itemList = document.querySelector(ITEM_LIST_SELECTOR);
    if (!itemList) return false;

    const current = document.querySelector(MOUNTED_OFFER_SELECTOR);
    const recommendations = [...itemList.children].find((element) =>
      element.querySelector(':scope > p.heading + ul')
    );
    recommendations?.classList.add('cro-cart-recommendations');

    recommendations?.querySelectorAll('.cm-upsell-atc__btn').forEach((button) => {
      if (button.dataset.croIconButton) return;
      const productTitle = button.closest('.produktkort')?.querySelector('.heading a')?.textContent?.trim();
      if (productTitle) button.setAttribute('aria-label', `Tilføj ${productTitle}`);
      button.dataset.croIconButton = 'true';
      button.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M6 7h12l-1.2 11.5a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.8L6 7Z"/>
          <path d="M9 7V5a3 3 0 0 1 6 0v2"/>
        </svg>`;
    });

    const block = cloneCachedBlock();
    if (!block) {
      current?.remove();
      return true;
    }

    if (current?.dataset.cmOfferVersion === String(cacheVersion)) {
      if (recommendations && current.nextElementSibling !== recommendations) {
        itemList.insertBefore(current, recommendations);
      }
      return true;
    }

    block.dataset.cmOfferVersion = String(cacheVersion);

    if (current) current.replaceWith(block);
    else itemList.insertBefore(block, recommendations || null);

    if (recommendations && block.nextElementSibling !== recommendations) {
      itemList.insertBefore(block, recommendations);
    }
    return true;
  };

  const fetchOfferBlock = async () => {
    const url = `${window.location.pathname}?sections=${encodeURIComponent(SECTION_ID)}`;
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Cart offers fetch failed: ${response.status}`);

    const sections = await response.json();
    const template = document.createElement('template');
    template.innerHTML = sections[SECTION_ID] || '';
    cachedBlock = template.content.querySelector('[data-cm-cart-cross-sell]');
    hasFetched = true;
    cacheVersion += 1;
  };

  const refresh = async () => {
    if (requestInFlight) {
      refreshQueued = true;
      return;
    }

    requestInFlight = true;
    let fetched = false;
    try {
      await fetchOfferBlock();
      fetched = true;
    } catch (error) {
      console.warn('[cm-cart-cross-sell]', error);
    } finally {
      requestInFlight = false;
      if (refreshQueued) {
        refreshQueued = false;
        refresh();
      } else if (fetched) {
        injectCachedBlock();
      }
    }
  };

  const dispatchCart = (cart) => {
    if (window.theme) window.theme.cart = cart;
    document.dispatchEvent(new CustomEvent('cart:fetched', { detail: cart }));
  };

  const submitUpgrade = async (form) => {
    const button = form.querySelector('button[type="submit"]');
    if (button?.disabled) return;

    const sourceLineKey = form.dataset.sourceLineKey;
    if (!sourceLineKey) return;

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
    }
    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!addResponse.ok) throw new Error(`Upgrade add failed: ${addResponse.status}`);

      const changeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: sourceLineKey, quantity: 0 })
      });
      if (!changeResponse.ok) throw new Error(`Upgrade swap failed: ${changeResponse.status}`);

      dispatchCart(await changeResponse.json());
    } catch (error) {
      console.warn('[cm-cart-upgrade]', error);
    } finally {
      if (button?.isConnected) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    }
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest?.('form[data-cm-cart-upgrade]');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      submitUpgrade(form);
    },
    true
  );

  const invalidateOffers = () => {
    cachedBlock = null;
    hasFetched = false;
    refresh();
  };

  document.addEventListener('cart:fetched', invalidateOffers);
  document.addEventListener('cart:offers:refresh', invalidateOffers);

  const cartRoot = document.querySelector(CART_ROOT_SELECTOR);
  if (cartRoot) {
    new MutationObserver(() => {
      if (!document.querySelector(ITEM_LIST_SELECTOR)) return;
      if (!hasFetched) {
        refresh();
        return;
      }
      injectCachedBlock();
    }).observe(cartRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
